import React from "react";
import "./LedgerMainFilter.scss";
import { useDispatch } from "react-redux";
import ListFilterButton from "./ListFilterButton";
import { commonAction } from "../../../redux/features/commonSlice";

interface Props {
  rightAction?: React.ReactNode;
  showFiltersBtn?: boolean;
}

const LedgerMainFilter: React.FC<Props> = ({
  rightAction,
  showFiltersBtn = true,
}) => {
  const dispatch = useDispatch();

  const handleOpenFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  return (
    <div className="home-filter-bar">
      <div className="action-group">
        {showFiltersBtn && <ListFilterButton />}

        {rightAction}
      </div>
    </div>
  );
};

export default LedgerMainFilter;
